module.exports = __webpack_public_path__ + "static/img/banner2.a485a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner2.png
// module id = QFm/
// module chunks = 1